import React, { useRef, useState } from 'react';
import {
  FiX, FiImage, FiUpload, FiTrash2, FiSun, FiMoon, FiMic, FiBell, FiVolume2,
  FiSliders, FiCheck, FiInfo, FiZap,
} from 'react-icons/fi';
import { usePhone } from '../../phone/PhoneContext';
import { PRESETS, prettySize, effectiveFx, isStrongDevice } from './background';

// Operator paneli sozlamalari: fon rasmi (o'zi yuklaydi), ko'rinish va ovoz.
// Fon rasmi shu kompyuterda saqlanadi — serverga yuborilmaydi.
export default function SettingsDrawer({
  look, setLook, bgUrl, bgSize, busy, onUpload, onRemove, onClose,
}) {
  const p = usePhone();
  const fileRef = useRef(null);
  const [over, setOver] = useState(false);

  const pick = (file) => { if (file) onUpload(file); };

  const custom = look.bg === 'custom' && !!bgUrl;

  return (
    <div className="op2-ov" onClick={onClose}>
      <div className="op2-drawer g" onClick={(e) => e.stopPropagation()}>
        <div className="op2-drawer-h">
          <FiSliders size={19} />
          <h3 style={{ flex: 1 }}>Sozlamalar</h3>
          <button className="op2-iconbtn" onClick={onClose} title="Yopish"><FiX size={17} /></button>
        </div>

        {/* === FON RASMI === */}
        <div className="op2-sec">
          <div className="op2-sec-t">Fon rasmi</div>

          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={(e) => { pick(e.target.files && e.target.files[0]); e.target.value = ''; }}
          />

          <div
            className={`op2-drop${over ? ' over' : ''}`}
            onClick={() => !busy && fileRef.current && fileRef.current.click()}
            onDragOver={(e) => { e.preventDefault(); setOver(true); }}
            onDragLeave={() => setOver(false)}
            onDrop={(e) => {
              e.preventDefault();
              setOver(false);
              const f = e.dataTransfer?.files && e.dataTransfer.files[0];
              pick(f);
            }}
          >
            {busy ? (
              <>
                <FiUpload size={22} />
                <div className="op2-drop-t">Rasm tayyorlanmoqda…</div>
              </>
            ) : (
              <>
                <FiImage size={22} />
                <div className="op2-drop-t">Rasmni shu yerga tashlang yoki bosing</div>
                <div className="op2-drop-s">
                  JPG, PNG, WEBP · 20 MB gacha. Katta rasm avtomatik kichraytiriladi.
                </div>
              </>
            )}
          </div>

          {bgUrl && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 11, marginTop: 11 }}>
              <div
                className="op2-thumb on"
                style={{ backgroundImage: `url(${bgUrl})`, height: 54, width: 90, flexShrink: 0, cursor: 'default' }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700 }}>Sizning rasmingiz</div>
                <div style={{ fontSize: 11.5, color: 'var(--g-tx3)' }}>
                  {bgSize ? prettySize(bgSize) : 'saqlangan'} · shu kompyuterda
                </div>
              </div>
              {look.bg !== 'custom' && (
                <button className="op2-btn" style={{ padding: '8px 12px', fontSize: 12.5 }} onClick={() => setLook({ ...look, bg: 'custom' })}>
                  <FiCheck size={14} /> Qo'yish
                </button>
              )}
              <button className="op2-sm" title="Rasmni o'chirish" onClick={onRemove}>
                <FiTrash2 size={15} />
              </button>
            </div>
          )}

          <label className="op2-lab">Tayyor fonlar</label>
          <div className="op2-thumbs">
            {PRESETS.map((pr) => (
              <button
                key={pr.key}
                className={`op2-thumb${look.bg === `preset:${pr.key}` ? ' on' : ''}`}
                style={{ background: pr.css }}
                onClick={() => setLook({ ...look, bg: `preset:${pr.key}` })}
                title={pr.label}
              >
                <span>{pr.label}</span>
              </button>
            ))}
            {custom && (
              <button
                className={`op2-thumb${look.bg === 'custom' ? ' on' : ''}`}
                style={{ backgroundImage: `url(${bgUrl})` }}
                onClick={() => setLook({ ...look, bg: 'custom' })}
                title="Sizning rasmingiz"
              >
                <span>Mening rasmim</span>
              </button>
            )}
          </div>
        </div>

        {/* === KO'RINISH === */}
        <div className="op2-sec">
          <div className="op2-sec-t">Ko'rinish</div>

          <label className="op2-lab">
            Fonni qoraytirish — matn o'qilishi uchun
          </label>
          <div className="op2-range">
            <input
              type="range" min="0" max="85" step="5"
              value={Math.round(look.scrim * 100)}
              onChange={(e) => setLook({ ...look, scrim: Number(e.target.value) / 100 })}
            />
            <span>{Math.round(look.scrim * 100)}%</span>
          </div>

          <label className="op2-lab">Panel rangi</label>
          <div className="op2-seg2">
            <button className={look.theme === 'dark' ? 'on' : ''} onClick={() => setLook({ ...look, theme: 'dark' })}>
              <FiMoon size={14} /> Qora
            </button>
            <button className={look.theme === 'light' ? 'on' : ''} onClick={() => setLook({ ...look, theme: 'light' })}>
              <FiSun size={14} /> Oq
            </button>
          </div>
        </div>

        {/* === TEZLIK === */}
        <div className="op2-sec">
          <div className="op2-sec-t">Tezlik</div>
          <div className="op2-seg2">
            <button className={look.fx === 'auto' ? 'on' : ''} onClick={() => setLook({ ...look, fx: 'auto' })}>
              Avto
            </button>
            <button className={look.fx === 'lite' ? 'on' : ''} onClick={() => setLook({ ...look, fx: 'lite' })}>
              <FiZap size={13} /> Yengil
            </button>
            <button className={look.fx === 'glass' ? 'on' : ''} onClick={() => setLook({ ...look, fx: 'glass' })}>
              Shisha
            </button>
          </div>
          <div style={{ fontSize: 11.5, color: 'var(--g-tx3)', marginTop: 8, lineHeight: 1.55 }}>
            «Shisha» — panel ortidagi rasm xiralashadi, lekin videokartaga og'ir: kuchsiz
            kompyuterda panel qotadi. «Yengil» — ko'rinish deyarli o'sha, lekin tez.
            {look.fx === 'auto' && (
              <> Bu kompyuter {isStrongDevice() ? 'kuchli' : 'kuchsiz'} deb aniqlandi —
                hozir <b>{effectiveFx(look) === 'lite' ? 'Yengil' : 'Shisha'}</b> rejim ishlayapti.</>
            )}
          </div>
        </div>

        {/* === OVOZ === */}
        <div className="op2-sec">
          <div className="op2-sec-t">Mikrofon va ovoz</div>

          {!p.micPanelOpen ? (
            <button className="op2-btn" style={{ width: '100%' }} onClick={() => p.openMicPanel(true)}>
              <FiMic size={15} /> Mikrofonni tekshirish
            </button>
          ) : (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 8 }}>
                <FiMic size={14} color="var(--g-tx3)" />
                <div className="op2-meter">
                  <i style={{
                    width: `${Math.round(Math.min(1, p.micLevel || 0) * 100)}%`,
                    background: p.micLevel > 0.6 ? 'var(--g-warn)' : 'var(--g-ok)',
                  }} />
                </div>
                <button className="op2-sm" onClick={p.closeMicPanel} title="Yopish"><FiX size={14} /></button>
              </div>
              <div style={{ fontSize: 11.5, color: 'var(--g-tx3)', marginBottom: 9, lineHeight: 1.5 }}>
                Gapiring — chiziq harakatlanishi kerak. Harakatlanmasa mikrofon ovoz bermayapti.
              </div>
              <div className="op2-list" style={{ maxHeight: 160 }}>
                {p.micDevices.length === 0 ? (
                  <div style={{ fontSize: 12.5, color: 'var(--g-tx3)' }}>Qurilma topilmadi</div>
                ) : p.micDevices.map((d) => (
                  <button
                    key={d.deviceId}
                    className="op2-lrow"
                    style={d.deviceId === p.micDeviceId ? { borderColor: 'var(--g-ok)' } : undefined}
                    onClick={() => p.chooseMic(d.deviceId)}
                    disabled={p.micBusy}
                  >
                    <span style={{
                      width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                      background: d.deviceId === p.micDeviceId ? 'var(--g-ok)' : 'var(--g-tx3)',
                    }} />
                    <span className="op2-lrow-n" style={{ fontWeight: 500, fontSize: 12.5 }}>{d.label}</span>
                  </button>
                ))}
              </div>
            </>
          )}

          <label className="op2-lab">
            <FiBell size={12} style={{ verticalAlign: -2, marginRight: 5 }} />
            Qo'ng'iroq ovozi balandligi
          </label>
          <div className="op2-range">
            <input
              type="range" min="0" max="100" step="5"
              value={Math.round(p.ringVolume * 100)}
              onChange={(e) => p.setRingVolume(Number(e.target.value) / 100)}
              onMouseUp={p.testRing}
            />
            <span>{Math.round(p.ringVolume * 100)}%</span>
          </div>
          <button className="op2-btn" style={{ width: '100%', marginTop: 9 }} onClick={p.testRing}>
            <FiVolume2 size={15} /> Qo'ng'iroq ovozini tinglash
          </button>

          {/* Quloqchin stolda yotgan bo'lsa ovoz baribir quloqchinga ketadi va
              hech kim eshitmaydi — shuning uchun karnayga HAM yuborish mumkin. */}
          {p.supportsRingOutput && (
            <>
              <label className="op2-lab">Qo'shimcha karnay</label>
              <select
                className="op2-in"
                value={p.ringOutput || ''}
                onChange={(e) => p.setRingOutput(e.target.value)}
              >
                <option value="">Faqat asosiy qurilmada jiringlasin</option>
                {p.ringOutputs.map((o) => (
                  <option key={o.deviceId} value={o.deviceId}>Karnay: {o.label}</option>
                ))}
              </select>
              <div style={{ fontSize: 11.5, color: 'var(--g-tx3)', marginTop: 6, lineHeight: 1.5 }}>
                Quloqchin yechilgan bo'lsa ham eshitish uchun kompyuter karnayini tanlang.
              </div>
            </>
          )}
        </div>

        <div style={{ display: 'flex', gap: 9, fontSize: 11.5, color: 'var(--g-tx3)', lineHeight: 1.55 }}>
          <FiInfo size={14} style={{ flexShrink: 0, marginTop: 2 }} />
          <span>
            Fon rasmi va ko'rinish sozlamalari faqat shu kompyuterning brauzerida saqlanadi —
            serverga yuborilmaydi va boshqa operatorlarga ko'rinmaydi.
          </span>
        </div>
      </div>
    </div>
  );
}
